export const headers = {
  date: { active: false, direction: false, value: "date" },
  path_name: { active: false, direction: false, value: "path_name" },
  user_name: { active: false, direction: false, value: "user_name" },
  status: { active: false, direction: false, value: "status" },
  modified: { active: false, direction: false, value: "modified" }
};

export default headers;
